import { render, staticRenderFns } from "./ComponentDetailsModal.vue?vue&type=template&id=63da07d5&scoped=true&"
import script from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ComponentDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetailsModal.vue?vue&type=style&index=0&id=63da07d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da07d5",
  null
  
)

export default component.exports